<template>
  <div>
    <div>
      <img
        class="backImg"
        :src="
          language === 'zh'
            ? require('@/assets/images/legalStatement/legalStatementBack.jpg')
            : require(
                '@/assets/images/legalStatement/en_legalStatementBack.jpg'
              )
        "
      />
    </div>
    <div class="bread">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="16">
          <slot name="breadcrumb"></slot>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="16">
          <div class="contentBox">
            <div class="leftBox">
              <div class="menuTitle">
                <span>{{ $t("route.noticesAndMap") }}</span>
              </div>
              <div
                :class="activeIndex == index ? 'activemenu' : 'menu'"
                v-for="(item, index) in legalAndMap"
                :key="index"
                @click="menuClick(item.path, index, item.title)"
              >
                <div class="menu-title">{{ item.title }}</div>
                <div class="menu-to">
                  <i class="el-icon-arrow-right" style="font-size: 14px"></i>
                </div>
              </div>
            </div>
            <div class="rightBox">
              <div class="boxTitle">{{ legalAndMap[activeIndex].title }}</div>
              <div class="content">
                <router-view />
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mixins } from "@/mixins/list";
export default {
  mixins: [mixins],
  data() {
    return {
      language: localStorage.getItem("language") || "zh",
      activeIndex: 0,
    };
  },
  watch: {
    $route: {
      handler(newValue, oldValue) {
        this.legalAndMap.forEach((Element, index) => {
          if (Element.path == this.$route.fullPath) {
            this.activeIndex = index;
          }
        });
      },
      immediate: true,
    },
  },
  methods: {
    menuClick(path, index) {
      this.activeIndex = index;
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.backImg {
  width: 100%;
  /* height: 300px; */
}
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.container {
  padding: 20px;
}
.contentBox {
  display: flex;
}
.leftBox {
  width: 20%;
  margin-right: 20px;
}
.menuTitle {
  padding: 10px 20px;
  background-color: #32589f;
  text-align: center;
}
.menuTitle > span {
  color: #fff;
}
.activemenu {
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #dcdfe6;
  border-top: 0px;
  cursor: pointer;
}
.activemenu > div {
  color: #32589f;
  font-weight: 800;
}
.menu {
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #dcdfe6;
  border-top: 0px;
  cursor: pointer;
  background-color: rgba(245, 245, 245, 1);
}
.menu > div {
  color: #333;
}
.menu-title {
  margin-left: 8px;
}
.rightBox {
  padding: 5px;
  width: 100%;
}
.boxTitle {
  font-size: 22px;
  font-weight: 800;
  padding-bottom: 10px;
  color: #015a9c;
  border-bottom: 1px solid #dcdfe6;
  letter-spacing: 2px;
}
.content {
  margin-top: 20px;
}
@media only screen and (max-width: 768px) {
  .backImg {
    width: 100%;
    height: auto;
  }
  .contentBox {
    display: block;
  }
  .leftBox {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
  .rightBox {
    /* padding: 10px 0; */
    width: 100%;
  }
  .boxTitle {
    font-size: 17px;
    letter-spacing: 0px;
  }
}
</style>